const initialState = {
  addNoteActive: false,
  formState: {
    data: {}
  },
};

export default function (state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case 'TOGGLE_ADD_NOTE': {
      return {
        ...state,
        addNoteActive: payload.active,
      };
    }
    case 'CLIENT_NOTES_FORM_CHANGE': {
      const { formState } = payload;
      return {
        ...state,
        formState,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/ClientModal/ClientNotes/ClientNotes.reducer.js